The responses the hirer selected when the draft was created.
